import { HttpConfig } from "@ogs-gmbh/ngx-http";

export const HTTP_DEFAULT_TIMEOUT: number = 3000;
export const HTTP_CONFIG: HttpConfig = {
  host: "pls.ogs.de",
  protocol: "https"
};
